try {
window.addEventListener('load', () => {
  const wrapper = document.querySelector(".wizzy-search-wrapper");
  const viewIcons = document.querySelectorAll(".boost-sd__view-as-icon");
  viewIcons.forEach(icon => {
    icon.addEventListener("click", () => {
      // Remove active state from all
      viewIcons.forEach(i => {
        i.classList.remove("boost-sd__view-as-icon--active");
        i.setAttribute("aria-checked", "false");
      });

      // Add active state to clicked icon
      icon.classList.add("boost-sd__view-as-icon--active");
      icon.setAttribute("aria-checked", "true");

      if (wrapper) {
        let mode = icon.dataset.value;

        if (mode.startsWith("grid--")) {
          mode = mode.replace("grid--", ""); 
        } else if (mode === "list") {
          mode = "1";
        }

        wrapper.setAttribute("wizzy-tile-view-level", mode);
      }
    });
  });
});


window.addEventListener("load", () => {
  if (window.wizzyConfig?.common?.isOnCategoryPage) {
    const pageKey = "scrollPositionInitialized_" + window.location.pathname;

    if (!sessionStorage.getItem(pageKey)) {
      sessionStorage.setItem("scrollPosition", 0);
      sessionStorage.setItem(pageKey, "true"); // mark only first load for this page
    }
  }
});


let scrollSaveTimeout;

window.addEventListener('scroll', function() {
    clearTimeout(scrollSaveTimeout);
    scrollSaveTimeout = setTimeout(function() {
        sessionStorage.setItem('scrollPosition', window.pageYOffset);
    }, 100); 
});

function restoreScrollWithAutoLoad() {
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    
    if (scrollPosition) {
        const targetScroll = parseInt(scrollPosition);
        
        window.scrollTo(0, targetScroll);
        
        setTimeout(() => {
            const actualScroll = window.pageYOffset;
            
            if (Math.abs(actualScroll - targetScroll) > 100) {
                smartScrollToPosition(targetScroll);
            }
        }, 300);
    }
}

function smartScrollToPosition(targetPosition) {
    let attempts = 0;
    const maxAttempts = 8;
    let lastHeight = 0;
    let sameHeightCount = 0;
    
    function attemptScroll() {
        attempts++;
        const currentHeight = document.documentElement.scrollHeight;
        const maxScrollable = currentHeight - window.innerHeight;
        const currentScroll = window.pageYOffset;
        
        
        // Stop if we've reached max attempts
        if (attempts >= maxAttempts) {
            window.scrollTo(0, Math.min(targetPosition, maxScrollable));
            return;
        }
        
        // Stop if height hasn't changed for 2 consecutive attempts
        if (currentHeight === lastHeight) {
            sameHeightCount++;
            if (sameHeightCount >= 2) {
                window.scrollTo(0, Math.min(targetPosition, maxScrollable));
                return;
            }
        } else {
            sameHeightCount = 0;
        }
        
        lastHeight = currentHeight;
        
        if (targetPosition <= maxScrollable) {
            window.scrollTo(0, targetPosition);
            return;
        }
        
        if (Math.abs(currentScroll - targetPosition) <= 200) {
            return;
        }
        
        window.scrollTo(0, maxScrollable);
        setTimeout(attemptScroll, 1200);
    }
    
    attemptScroll();
}

if(window.location.pathname === "/pages/search" || window.wizzyConfig?.common?.isOnCategoryPage)
window.addEventListener('load', restoreScrollWithAutoLoad);



    var lastClickedFilter = null;

  let searchinput= document.querySelector('.t4s-search-header__input.t4s-input__currentcolor');
  if(searchinput){
    searchinput.addEventListener('click',function() {
      // document.body.classList.add('t4s-lock-scroll');
    });
  }

  function addlisterforquickwhislist(){
    setTimeout(() => {
      
    const qvButtons = document.querySelectorAll(".autocomplete-top-products .product-quickviews-btn");
    const addtocart = document.querySelectorAll(".autocomplete-top-products .new-collection__add");
    const whislistbutton =  document.querySelectorAll(".autocomplete-top-products .swym-icon");
    if(qvButtons){
   qvButtons.forEach(btn => {
    btn.removeEventListener("click", window.handleQvClick); 
    btn.addEventListener("click", window.handleQvClick);
  });
}
 if(addtocart){
  addtocart.forEach(btn => {
    btn.removeEventListener("click", window.handleQvClick); 
    btn.addEventListener("click", window.handleQvClick);
  });
}

if(whislistbutton) {
    whislistbutton.forEach(btn => {
    btn.removeEventListener("click", window.handleWishlistClick); 
    btn.addEventListener("click", window.handleWishlistClick);
  });
}
    }, 500);


  }

  function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");
   
        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          
          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}

window.onWizzyScriptLoaded = function () {
  

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
      function (data) {
        // console.log("AFTER_WIZZY_API_RESPONDED : ",data);
        if (data.api === "autocomplete") {
          data?.response?.payload?.categories?.forEach((category) => {
            if (category.filters.categories[0].includes("_wzAc")) {
              category.payload.forEach((item) => {
                if (item.key === "relatedCategories") {
                  item.value[0].url = undefined;
                }
              })
            }
          })
        }
        return data;
      }
  );
  

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
  const filterItems = document.querySelectorAll('.wizzy-facet-list-item');
  filterItems.forEach((item) => {
    item.addEventListener('click', () => {
      lastClickedFilter = item;
       if (lastClickedFilter) {
      setTimeout(() => {
        
        lastClickedFilter.scrollIntoView({
          behavior: "instant", 
          block: "center"
        });
      }, 500); 
    }
    });
  });
      if(window.innerWidth > 768){
      let searchicon= document.querySelectorAll('.facet-head-search-icon');
 
      if (searchicon){
        searchicon.forEach((icon)=>{
           icon.click();
        });
       
      }
    }
      document.body.classList.remove('t4s-lock-scroll');
         const qvButtons = document.querySelectorAll(".product-quickviews-btn");
         const addtocart = document.querySelectorAll(".new-collection__add");
         const whislistbutton = document.querySelectorAll(".wishlist-btn.wishlist-btn-loader-app.wishlist-btn-list")
         if(qvButtons){
  qvButtons.forEach(btn => {
    btn.removeEventListener("click", window.handleQvClick); // avoid duplicates
    btn.addEventListener("click", window.handleQvClick);
  });
}
 if(addtocart){
  addtocart.forEach(btn => {
    btn.removeEventListener("click", window.handleQvClick); // avoid duplicates
    btn.addEventListener("click", window.handleQvClick);
  });
}

if(whislistbutton) {
    whislistbutton.forEach(btn => {
    btn.removeEventListener("click", window.handleWishlistClick); // avoid duplicates
    btn.addEventListener("click", window.handleWishlistClick);
  });
}

const wrapper = document.querySelector(".wizzy-search-wrapper");
  const viewIcons = document.querySelectorAll(".boost-sd__view-as-icon");

  viewIcons.forEach(icon => {
    icon.addEventListener("click", () => {
      // Remove active state from all
      viewIcons.forEach(i => {
        i.classList.remove("boost-sd__view-as-icon--active");
        i.setAttribute("aria-checked", "false");
      });

      // Add active state to clicked one
      icon.classList.add("boost-sd__view-as-icon--active");
      icon.setAttribute("aria-checked", "true");

   
      if (wrapper) {
        let mode = icon.dataset.value; 

        if (mode.startsWith("grid--")) {
          mode = mode.replace("grid--", ""); 
        } else if (mode === "list") {
          mode = "1"; // list → 1
        }

        wrapper.setAttribute("wizzy-tile-view-level", mode);
      }
    });
  });
  gridFiltersToggleOnOverflow();

  return data;
    });
      window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // data.filters.showOOSProductsInOrder = "true";
    // console.log("data",data);

  return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        if(window.wizzyConfig.common.isOnCategoryPage){
data.search.configs.sorts.configs = data.search.configs.sorts.configs.filter(item => item.field !== 'relevance');
  }
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 1500,
            mobile: 300
        },
       window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
    if(window.innerWidth < 768){

    data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
    "dom": "#searchInput",
    "type": "text"
   };
    }
      return data;
    },1);
        window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
            window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 700,
            mobile: 300
        }
       window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
    if(window.innerWidth < 768){

    data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
    "dom": "#searchInput",
    "type": "text"
   };
    }
    else {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
    "dom": "header input",
    "type": "text"
   };
    }
      return data;
    },1);
     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if(document.querySelector('#shopify-section-template--22662958219572__hero_image_VFDnLB')){
        document.querySelector('#shopify-section-template--22662958219572__hero_image_VFDnLB').style.display = "none";
      }
      
      if(document.querySelector('#shopify-section-template--22662958219572__new_col_UDFwN3')){
        document.querySelector('shopify-section-template--22662958219572__new_col_UDFwN3').style.display = "none";
      }


    const wizzy_back_button=document.querySelector('.wizzy-search-back');
    if(wizzy_back_button){
      wizzy_back_button.click();
    }

 return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      try {
        if (data.api === "search" || data.api === "filter") { 
        var facets = data?.response?.payload?.facets;
        for (let i = 0; i < facets.length; i++) {
          if (facets[i].key === "brands") {
              let data = facets[i]?.data;
              if(data){
              data.sort((a, b) => a.key.localeCompare(b.key));
              facets[i].data = data;
              }
          }
        }
      }
      } catch (error) {
        console.log("error",error);
      }
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {

      try{
    products.forEach((product) => {
        product.attributes?.forEach((attr) => {
          if (attr.id === "product_fregrance_type_custom") {
            let fragrance_type = attr.values[0]?.value[0];
            product.fragranceType = fragrance_type;
          }
         
          if (attr.id ===  "product_product_name_custom") {
            let product_name = attr.values[0]?.value[0];
            product.productType = product_name;
          }
          
          if (attr.id ===  "product_sale_custom") {
            if(attr.values[0]?.value[0] === "Yes"){
            let issale = attr.values[0]?.value[0];
            product.isSale = issale;
            let discount = (product.sellingPrice * 15) / 100;
            let discounted = product.sellingPrice - discount;
            product.discountedPrice = (Math.ceil(discounted * 100) / 100).toFixed(2);
            }
          }          
             
        });
      });
    }
    catch(e){
      console.log(e);
    }
   return products;
    });
   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      try {
          const collectionHandle = window.wizzyConfig?.common?.collectionHandle;

  if (collectionHandle && window.wizzyConfig.common.isOnCategoryPage) {
    if(document.querySelectorAll(".wizzy-result-product a")){
    document.querySelectorAll(".wizzy-result-product a").forEach(link => {
      const url = new URL(link.href);

      // Only update product URLs
      if (url.pathname.startsWith("/products/")) {
        url.pathname = `/collections/${collectionHandle}${url.pathname}`;
        link.href = url.toString();
      }
    });
  }
  }
        
      
      if(window.innerWidth < 768){
  const wrapper = document.querySelector(".wizzy-search-summary-container");

  if (wrapper && wrapper.innerHTML.trim() === "") {
    const total = data?.data?.response?.payload?.total || 0;
    const query = data?.data?.response?.payload?.filters?.q || "";

    wrapper.innerHTML = `
      <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
    `;
  }
}

  const filterContainerSelector = '.wizzy-search-filters-left'
  if(filterContainerSelector){
  const filterItems = document.querySelectorAll('.wizzy-facet-list-item');
  const filterContainer = document.querySelector(filterContainerSelector);

  filterItems.forEach((item) => {
    item.addEventListener('click', () => {
      if (filterContainer) {
        localStorage.setItem('wizzyFilterScrollTop', filterContainer.scrollTop);
      }
    });
  });
      const savedScroll = localStorage.getItem('wizzyFilterScrollTop');
      if (savedScroll !== null && filterContainer) {
        setTimeout(() => {
          if(filterContainer)
          filterContainer.scrollTop = parseInt(savedScroll, 10);
        }, 100);
  }
}

      if(window.innerWidth > 768){
      let searchicon= document.querySelectorAll('.facet-head-search-icon');

      if (searchicon){
        searchicon.forEach((icon)=>{
           icon.click();
        });
       
      }
    }
      document.body.classList.remove('t4s-lock-scroll');
         const qvButtons = document.querySelectorAll(".product-quickviews-btn");
         const addtocart = document.querySelectorAll(".new-collection__add");
         const whislistbutton = document.querySelectorAll(".swym-icon.swym-heart ")
         if(qvButtons){
  qvButtons.forEach(btn => {

    btn.removeEventListener("click", window.handleQvClick); 
    btn.addEventListener("click", window.handleQvClick);
  });
}
 if(addtocart){
  addtocart.forEach(btn => {
    btn.removeEventListener("click", window.handleQvClick);
    btn.addEventListener("click", window.handleQvClick);
  });
}

if(whislistbutton) {
    whislistbutton.forEach(btn => {
    btn.removeEventListener("click", window.handleWishlistClick); 
    btn.addEventListener("click", window.handleWishlistClick);
  });
}

const wrapper = document.querySelector(".wizzy-search-wrapper");
  const viewIcons = document.querySelectorAll(".boost-sd__view-as-icon");
  viewIcons.forEach(icon => {
    icon.addEventListener("click", () => {
      // Remove active state from all
      viewIcons.forEach(i => {
        i.classList.remove("boost-sd__view-as-icon--active");
        i.setAttribute("aria-checked", "false");
      });

      icon.classList.add("boost-sd__view-as-icon--active");
      icon.setAttribute("aria-checked", "true");

      if (wrapper) {
        let mode = icon.dataset.value;

        if (mode.startsWith("grid--")) {
          mode = mode.replace("grid--", ""); 
        } else if (mode === "list") {
          mode = "1";
        }

        wrapper.setAttribute("wizzy-tile-view-level", mode);
      }
    });
  });
  gridFiltersToggleOnOverflow();
  } catch (error) {
        console.log(error);
        
      }
      _swat.initializeActionButtons(".wizzy-search-results");

  return data;
    });

};

  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
function updateBodyClass() {
    const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
    autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
}
const config = {
    childList: !0,
    subtree: !0,
    attributes: !0,
    attributeFilter: ["style"]
}
  , callback = function(mutationsList, observer2) {
    for (const mutation of mutationsList) {
        updateBodyClass();
        break
    }
}
  , observer = new MutationObserver(callback);
targetNode && (observer.observe(targetNode, config),
updateBodyClass());

    if(window.innerWidth <= 768) {
        const front_input = document.querySelector(".t4s-site-nav__icon .t4s-icon--search");
  
        front_input && front_input.addEventListener("click", function(e) {
                // addlisterforquickwhislist();
      e.preventDefault();
            const back_input = document.querySelector("#search_mini_form input");
            back_input && back_input.click();
            let search_form = document.querySelector("#search_mini_form");
            search_form && (search_form.style.display = "block",
            setTimeout( () => {
                let search_bar = search_form.querySelector("input");
                search_bar && search_bar.click()
            }
            , 300));
            let autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
            autocomplete && (autocomplete.style.top = "83px")
        })
    }
}
catch (e){
  console.log(e);
}